/* Mobile wheel: fixed circle, edge-to-circle cross, then icon + media together. */
(() => {
  if (window.akHomeMobileWheelsInstalled) return;
  window.akHomeMobileWheelsInstalled = true;
  const mobile = matchMedia('(max-width:1200px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const visible = new Set(), installed = new WeakSet(), wheels = new Set();
  const idleSpeed = 4.5, scrollBoostLimit = 240;
  let frame = 0, revealFrame = 0, lastTime = 0, speed = idleSpeed;
  let velocity = 0, scrollAt = 0, scrollTop = 0, direction = 1;
  const readTop = () => Math.max(window.scrollY, document.scrollingElement?.scrollTop || 0, document.body.scrollTop, document.getElementById('MainContent')?.scrollTop || 0);
  const rotations = new Map(), active = new Set();
  function syncRotations() {
    active.clear();
    wheels.forEach(wheel => {
      let item = rotations.get(wheel);
      const run = mobile.matches && !reduced.matches && !document.hidden &&
        visible.has(wheel) && (wheel.dataset.akWheelEntered === 'true' || wheel.dataset.akWheelReady === 'true');
      if (!item && run) {
        const icon = wheel._akWheelRotor;
        if (!icon) return;
        const animation = icon.animate([{transform:'rotate(0deg)'},{transform:'rotate(360deg)'}],
          {duration:80000,iterations:Infinity,easing:'linear'});
        animation.currentTime = 800000000;
        animation.pause();
        item = {icon,animation}; rotations.set(wheel,item);
      }
      if (!item) return;
      if (run) {
        item.animation.updatePlaybackRate(speed / idleSpeed);
        if (item.animation.playState !== 'running') item.animation.play();
        item.icon.style.willChange = 'transform'; active.add(item.animation);
      } else {
        item.animation.pause(); item.icon.style.removeProperty('will-change');
      }
    });
  }
  function stop() {
    cancelAnimationFrame(frame); frame = 0; lastTime = 0;
    cancelAnimationFrame(revealFrame); revealFrame = 0;
    rotations.forEach(({animation,icon}) => { animation.pause(); icon.style.removeProperty('will-change'); });
    active.clear();
  }
  // Native transform timelines keep idle rotation off the JS frame loop.
  // Only the short acceleration/deceleration envelope needs JS frames.
  function run(time) {
    frame = 0;
    if (!mobile.matches || reduced.matches || document.hidden || !active.size) { lastTime = 0; return; }
    const dt = lastTime ? Math.min(48,time - lastTime) : 16;
    lastTime = time;
    const activeVelocity = velocity * Math.exp(-Math.max(0,time - scrollAt) / 220);
    const target = direction * (idleSpeed + Math.min(scrollBoostLimit,activeVelocity * .65));
    speed += (target - speed) * (1 - Math.exp(-dt / (Math.abs(target) > Math.abs(speed) ? 90 : 220)));
    active.forEach(animation => animation.updatePlaybackRate(speed / idleSpeed));
    if (activeVelocity > .1 || Math.abs(speed-direction*idleSpeed) > .1) frame = requestAnimationFrame(run);
    else {
      speed = direction * idleSpeed; lastTime = 0;
      active.forEach(animation => animation.updatePlaybackRate(direction));
    }
  }
  function start() {
    syncRotations();
    if (!frame && active.size && mobile.matches && !reduced.matches && !document.hidden) frame = requestAnimationFrame(run);
  }
  function layout(wheel) {
    const rect = wheel.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const previous = wheel.closest('.shopify-section')?.previousElementSibling;
    const arrow = [...(previous?.querySelectorAll('.ak-featured-header .ak-featured-header-link') || [])]
      .find(element => element.getBoundingClientRect().width > 2);
    // Follow the border-owning cell, not its inset arrow/link content.
    const axis = arrow
      ? arrow.getBoundingClientRect().left + (parseFloat(getComputedStyle(arrow).borderLeftWidth) || 1) / 2 - rect.left
      : rect.width / 2 + .5;
    wheel.style.setProperty('--ak-mobile-wheel-axis',`${axis}px`);
    wheel.style.setProperty('--ak-mobile-wheel-size',`${Math.min(rect.width,rect.height) * .77}px`);

  }
  function enterWheel(wheel) {
    if(wheel.dataset.akWheelEntered==='true')return;
    layout(wheel);
    wheel.dataset.akWheelEntered='true';
    wheel.dataset.akWheelPhase='top';
    wheel.classList.add('is-wheel-entered');
    start();
  }
  function complete(wheel) {
    if (wheel.dataset.akWheelReady === 'true') return;
    enterWheel(wheel);
    clearTimeout(wheel._akWheelFallback);
    wheel._akWheelLowerCleanup?.();
    wheel.dataset.akWheelReady = 'true';
    wheel.dataset.akWheelPhase = 'ready';
    wheel.classList.add('is-wheel-ready');
    start();
    // Only the bottom ray releases the following section.
    wheel.dispatchEvent(new CustomEvent('ak:mobile-wheel-ready',{bubbles:true}));
  }
  function drawLower(wheel) {
    if(wheel._akWheelLowerStarted || wheel.dataset.akWheelReady==='true')return;
    wheel._akWheelLowerStarted=true;
    const ray=wheel.querySelector('.ak-wheel-ray--bottom');
    const finish=()=>{if(!document.hidden)complete(wheel);};
    const ended=event=>{if(event.target===ray && event.propertyName==='transform')finish();};
    wheel._akWheelLowerCleanup=()=>{ray.removeEventListener('transitionend',ended);};
    ray.addEventListener('transitionend',ended);
    wheel.dataset.akWheelPhase='lower';
    wheel.classList.add('is-wheel-lower-drawing');
    if(reduced.matches){complete(wheel);return;}
    // Safari can omit transitionend after fast scrolling or suspension.
    wheel._akWheelFallback=setTimeout(finish,420);
  }

  const motionObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
    reconcilePassed();
    if (visible.size) start(); else stop();
  },{rootMargin:'100px'});
  const sizes = new ResizeObserver(entries => entries.forEach(({target}) => layout(target)));
  function checkReveal(wheel) {
    if (!mobile.matches || document.hidden || wheel.dataset.akWheelReady === 'true') return;
    const circle = wheel.querySelector('.ak-catalogue-entry-emblem').getBoundingClientRect();
    if (!circle.width) return;
    const viewportHeight=window.innerHeight;
    if(circle.top < viewportHeight-45)enterWheel(wheel);
    if(circle.bottom<=45){complete(wheel);return;}
    // Bottom of the circle is 20% above the viewport's bottom edge.
    if(circle.bottom<=viewportHeight*.8){enterWheel(wheel);drawLower(wheel);}
  }

  function reconcilePassed() {
    wheels.forEach(checkReveal);
  }
  function queueReveal(){
    if(!revealFrame && !document.hidden)revealFrame=requestAnimationFrame(()=>{revealFrame=0;reconcilePassed();});
  }
  function init() {
    document.querySelectorAll('[data-ak-mobile-wheel]').forEach(wheel => {
      if (installed.has(wheel)) { layout(wheel); return; }
      installed.add(wheel); wheels.add(wheel);
      const icon = wheel.querySelector('.ak-catalogue-entry-emblem > svg');
      if (icon) {
        // Animate an HTML layer. Rotating an SVG root made Chrome repaint
        // the vector on the main thread even with will-change:transform.
        const rotor = document.createElement('span');
        rotor.className = 'ak-mobile-wheel-rotor';
        icon.before(rotor); rotor.append(icon);
        wheel._akWheelRotor = rotor;
      }
      layout(wheel);
      sizes.observe(wheel); motionObserver.observe(wheel);
    });
    scrollTop = readTop(); scrollAt = performance.now(); velocity = 0;
    queueReveal(); start();
  }
  document.addEventListener('scroll', () => {
    const now = performance.now(),top = readTop();
    if (top !== scrollTop) direction = top > scrollTop ? 1 : -1;
    velocity = Math.min(1200,Math.abs(top - scrollTop) * 1000 / Math.max(8,now - scrollAt));
    scrollTop = top; scrollAt = now;
    queueReveal(); start();
  },{capture:true,passive:true});
  function resumeWheels(){
    stop();visible.clear();
    wheels.forEach(wheel=>{
      if(wheel._akWheelLowerStarted && wheel.dataset.akWheelReady!=='true')complete(wheel);
      const r=wheel.getBoundingClientRect();if(r.width>0&&r.bottom>-100&&r.top<innerHeight+100)visible.add(wheel);
    });
    init();
  }
  window.addEventListener('ak:browser-resume',resumeWheels);
  document.addEventListener('visibilitychange',() => document.hidden ? stop() : resumeWheels());
  window.addEventListener('pagehide',stop);
  window.addEventListener('pageshow',init);
  window.addEventListener('resize',init,{passive:true});
  mobile.addEventListener('change',() => { stop(); init(); });
  reduced.addEventListener('change',() => { stop(); init(); });
  document.addEventListener('shopify:section:load',init);
  init();
})();
